// reformated the category path.
// legacy logic from the old website for brochureRequest event.
export const getReformatCategoryPath = (pathname: string) => {
    const categoryPath = pathname.replace('-', ' ').split('/');
    categoryPath.splice(0, 2);

    return categoryPath.join('/ ');
};
